import { Box, Button, SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRoute } from '../../router';
import { Sparkles } from 'lucide-react';

// ─── Styled ───────────────────────────────────────────────────────────────────

const PillRoot = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  background: '#f3f4f6',
  borderRadius: 999,
  padding: 2,
  flexShrink: 0,
});

const PillBtn = styled(Button)<{ $active: boolean }>(({ $active }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  height: 26,
  padding: '6px 12px',
  borderRadius: 999,
  fontSize: '0.75rem',
  fontWeight: 600,
  lineHeight: 1,
  border: $active ? '1px solid #e5e7eb' : '1px solid transparent',
  background: $active ? '#ffffff' : 'transparent',
  color: $active ? '#111827' : '#6b7280',
  boxShadow: $active ? '0 1px 2px 0 rgba(0,0,0,0.06)' : 'none',
  cursor: 'pointer',
  transition: 'color 150ms, background 150ms, box-shadow 150ms',
  fontFamily: 'inherit',
  '&:hover': { color: '#111827' },
}));

// ─── Component ────────────────────────────────────────────────────────────────

export function ViewToggle({ sx }: { sx?: SxProps }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isSimple   = location.pathname.includes(getRoute('plansSimple')) || location.pathname.includes('progress-tracker');
  const isAdvanced = location.pathname.includes(getRoute('plansAdvanced'));

  return (
    <PillRoot sx={sx}>
      <PillBtn  $active={isSimple}
                onClick={() => navigate(getRoute('plansSimple'))}>
        <Sparkles size={14} aria-hidden style={{color: '#3b82f6'}} />
        <span style={{background: 'linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>A.I. Guide</span>
      </PillBtn>
      <PillBtn $active={isAdvanced} onClick={() => navigate(getRoute('plansAdvanced'))}>
        Advanced
      </PillBtn>
    </PillRoot>
  );
}
